import { didApiUrl } from '@/environment';
import { authenticatedAxios } from '@/services/auth';
import { CreatePremiumPlusAvatarRequest, PremiumPlusAvatarPayload } from '../types';

const createAvatar = async (payload: CreatePremiumPlusAvatarRequest) => {
    const response = await authenticatedAxios.post(`${didApiUrl}/clips/avatars`, payload);
    return response.data;
};

export const createDvpAvatar = async (payload: PremiumPlusAvatarPayload) => {
    // TODO: implement draft logic
    if (!payload.source_url) {
        throw new Error('source_url is required');
    }

    return createAvatar({
        source_url: payload.source_url,
        consent_id: payload.consent_id,
        gender: payload.gender ?? 'male',
        config: {
            is_greenscreen: payload.is_greenscreen ?? false,
            greenscreen: payload.greenscreen,
            short_train: (payload.shortTrainDuration ?? 0) >= 2,
            trim_video_len: payload.shortTrainDuration,
        },
        idle_video: payload.idle_video,
        thumbnail_url: payload.thumbnail_url,
        name: payload.name,
    });
};
